export default __webpack_public_path__ + "img/check-bold-grey.6dbf9042.svg";